module.exports = __webpack_public_path__ + "static/img/charter.bd2fc492.png";